module.exports = __webpack_public_path__ + "static/img/sold_out.3e34aa8f.png";